<template>
  <popConfirmButton
    :cancel-text="$t('qu-xiao')"
    :ok-text="$t('shan-chu')"
    :toolTipTitle="$t('shan-chu')"
    class="card-delete-button"
    @confirm="handleDelete"
  >
    <template #title>
      <div>
        {{
          $t(
            'gai-mo-ban-bei-che-di-shan-chu-hou-wu-fa-zhao-hui-que-ren-shi-fou-shan-chu'
          )
        }}
      </div>

      <a-checkbox v-model:checked="checked">
        {{
          $t('ling-cun-zuo-pin-zhi-isteamright-tuan-dui-ge-ren-kong-jian', [
            isTeamRight ? $t('tuan-dui') : $t('ge-ren'),
          ])
        }}
      </a-checkbox>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </popConfirmButton>
</template>

<script lang="ts" setup>
import popConfirmButton from './pop-confirm-button.vue'
import type { Template } from '~/api/interface'
import { useDetector } from '~/hooks/useDetector'
const checked = ref(true)
const { isTeamRight } = useDetector()
const ctx: any = inject('personal-page-ctx')
const cardItem = inject<Template>('card-item')

const handleDelete = () => {
  cardItem
    ? ctx.actionDelete(cardItem, checked.value)
    : ctx.actionDelete(undefined, checked.value)
}
</script>
<style lang="scss">
.card-delete-button {
  flex: 1;
  border-radius: 6px;
}
</style>
